import React from 'react';
import { IconProps } from '../icons/icons';

/**
 * ClearAll icon component
 *
 * @param props - SVG props
 */

export const ClearAll: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 16, height = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.33333 8.66663H12.6667V7.33329H3.33333V8.66663ZM2 11.3333H11.3333V9.99996H2V11.3333ZM4.66667 4.66663V5.99996H14V4.66663H4.66667Z'
      fill={color}
    />
  </svg>
);

export default ClearAll;
